export const tunnels = [
	{
		name: 'Hobby',
		width: [2500, 3500, 4500],
		length: [4000, 6000, 8000, 10000, 12000, 14000, 16000, 18000, 20000],
		gableEnd: [
			{
				name: 'Cladding',
				ends: {
					'2500': {
						'PVC': 'PVC flap gable',
						'SINGLE_TIMBER': 'Single Timber Hinged Door',
						'SINGLE_STEEL': 'Single Steel Hinged Door',
						'SINGLE_ALU_EXTERNAL': 'Single Aluminium Sliding door (slides externally)'
					},
					'3500': {
						'PVC': 'PVC flap gable',
						'SINGLE_TIMBER': 'Single Timber Hinged Door',
						'SINGLE_STEEL': 'Single Steel Hinged Door',
						'SINGLE_ALU_EXTERNAL': 'Single Aluminium Sliding door (slides externally)'
					},
					'4500': {
						'PVC': 'PVC flap gable',
						'SINGLE_TIMBER': 'Single Timber Hinged Door',
						'SINGLE_STEEL': 'Single Steel Hinged Door',
						'SINGLE_ALU_INTERNAL': 'Single Aluminium Sliding door (slides internally)',
						'DOUBLE_STEEL': 'Double Steel Hinged Doors'
					},
				}
			},
			{
				name: 'Folded',
				ends: {
					'2500': {
						'PVC': 'PVC flap gable',
						'SINGLE_TIMBER': 'Single Timber Hinged Door',
						'SINGLE_STEEL': 'Single Steel Hinged Door'
					},
					'3500': {
						'PVC': 'PVC flap gable',
						'SINGLE_TIMBER': 'Single Timber Hinged Door',
						'SINGLE_STEEL': 'Single Steel Hinged Door'
					},
					'4500': {
						'PVC': 'PVC flap gable',
						'SINGLE_TIMBER': 'Single Timber Hinged Door',
						'SINGLE_STEEL': 'Single Steel Hinged Door',
						'DOUBLE_STEEL': 'Double Steel Hinged Doors'
					},
				}
			},
		],
		colors: ['TRANSPARENT']
	},
	{
		name: 'Mid',
		width: [5500, 6000],
		length: [6000, 8000, 10000, 12000, 14000, 16000, 18000, 20000, 22000, 24000, 26000, 28000, 30000, 32000, 34000, 36000, 38000, 40000, 42000, 44000, 46000, 48000, 50000],
		gableEnd: [
			{
				name: 'Cladding',
				ends: {
					'5500': {
						'PVC': 'PVC flap gable',
						'DOUBLE_TIMBER': 'Double Timber Hinged doors',
						'SINGLE_ALU_INTERNAL': 'Single Aluminium Sliding door (slides internally)',
						'DOUBLE_ALU_INTERNAL': 'Double Aluminium Sliding door (slides internally)',
						'DOUBLE_STEEL': 'Double Steel Hinged Doors'
					},
					'6000': {
						'PVC': 'PVC flap gable',
						'DOUBLE_TIMBER': 'Double Timber Hinged doors',
						'SINGLE_ALU_INTERNAL': 'Single Aluminium Sliding door (slides internally)',
						'DOUBLE_ALU_INTERNAL': 'Double Aluminium Sliding door (slides internally)',
						'DOUBLE_STEEL': 'Double Steel Hinged Doors'
					},
				}
			},
			{
				name: 'Folded',
				ends: {
					'5500': {
						'PVC': 'PVC flap gable',
						'DOUBLE_TIMBER': 'Double Timber Hinged doors',
						'DOUBLE_STEEL': 'Double Steel Hinged Doors'
					},
					'6000': {
						'PVC': 'PVC flap gable',
						'DOUBLE_TIMBER': 'Double Timber Hinged doors',
						'DOUBLE_STEEL': 'Double Steel Hinged Doors'
					},
				}
			},
		],
		colors: ['TRANSPARENT']
	},
	{
		name: 'Commercial',
		width: [7000, 8000, 9000],
		length: [8000, 10000, 12000, 14000, 16000, 18000, 20000, 22000, 24000, 26000, 28000, 30000, 32000, 34000, 36000, 38000, 40000, 42000, 44000, 46000, 48000, 50000],
		gableEnd: [
			{
				name: 'Cladding',
				ends: {
					'7000': {
						'DOUBLE_TIMBER': 'Double Timber Hinged doors',
						'DOUBLE_ALU_INTERNAL': 'Double Aluminium Sliding door (slides internally)',
						'STEEL': 'Steel gable with no doors',
						'HALF_MOON': 'Half moon'
					},
					'8000': {
						'DOUBLE_TIMBER': 'Double Timber Hinged doors',
						'DOUBLE_ALU_INTERNAL': 'Double Aluminium Sliding door (slides internally)',
						'STEEL': 'Steel gable with no doors',
						'HALF_MOON': 'Half moon'
					},
					'9000': {
						'DOUBLE_TIMBER': 'Double Timber Hinged doors',
						'DOUBLE_ALU_INTERNAL': 'Double Aluminium Sliding door (slides internally)',
						'STEEL': 'Steel gable with no doors',
						'HALF_MOON': 'Half moon'
					},
				}
			},
			{
				name: 'Folded',
				ends: {
					'7000': {
						'DOUBLE_TIMBER': 'Double Timber Hinged doors',
					},
					'8000': {
						'DOUBLE_TIMBER': 'Double Timber Hinged doors',
					},
					'9000': {
						'DOUBLE_TIMBER': 'Double Timber Hinged doors',
					},
				}
			},
		],
		colors: ['TRANSPARENT', 'GREEN/WHITE']
	},
]